import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'

export const $playerSubscriptionLimitationsTranslations = combine(
  i18n.$t,
  ({ t }) => ({
    subscription_upgrade_required_title: t(
      'subscription_upgrade_required_title'
    ),
    cellular_internet_only_title: t('cellular_internet_only_title'),
    cellular_internet_only_text: t('cellular_internet_only_text'),
    casting_not_allowed: t('casting_not_allowed'),
    upgrade_button: t('upgrade_button'),
    cancel_button: t('cancel'),
    ok_button: t('ok'),
  })
)

export const $playerSubscriptionLimitationsQualityTranslations = combine(
  i18n.$t,
  ({ t }) =>
    (qualityStr: string) => {
      const quality = `${qualityStr}p`
      return {
        subscription_upgrade_required_text: t(
          'subscription_upgrade_required_text',
          { quality }
        ),
        rewind_one_quality_available: t('rewind_one_quality_available', {
          quality,
        }),
        no_allowed_quality_available: t('no_allowed_quality_available', {
          quality,
        }),
      }
    }
)
